import React, { PureComponent } from 'react'
import { Input } from 'hljd'
import styles from './style.module.less'
export default class extends PureComponent {
  static defaultProps = {
    showTotal: true,
    type: 'input'
  }

  inputChinese = false

  handleCompositionStart = () => {
    this.inputChinese = true
  }

  handleCompositionEnd = e => {
    e.target = e.currentTarget
    this.inputChinese = false
    this.changeHandle(e)
  }

  changeHandle = e => {
    const { maxText, inputChange } = this.props
    let value = e.target.value
    if (maxText && !this.inputChinese) {
      value = value.substring(0, maxText)
    }
    inputChange && inputChange(value)
  }

  render() {
    const { maxText, inputChange, showTotal, value, type, ...rest } = this.props
    const len = (value || '').length
    const Inp = type === 'input' ? Input : Input.TextArea
    return (
      <span className={styles.input}>
        <Inp
          {...rest}
          value={value}
          className={styles.el}
          onChange={this.changeHandle}
          onCompositionStart={this.handleCompositionStart}
          onCompositionEnd={this.handleCompositionEnd}
        />
        {maxText !== undefined && showTotal ? (
          <span className={styles.total_text}>
            <span>{len}</span> / {maxText}
          </span>
        ) : null}
      </span>
    )
  }
}
